import { Component, OnInit, Input } from '@angular/core';
import { SafeResourceUrl, 
         DomSanitizer } from '@angular/platform-browser';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 
import * as myGlobals from '../../global';

@Component({
  selector: 'tn-ads-list-item',
  templateUrl: '../../themes/default/html/tnadslist-item.component.html',
  styleUrls: ['../../themes/default/css/tnadslist-item.component.scss']
})
export class TnadslistItemComponent implements OnInit {

  @Input()
  adData: any;
  imageData: any;
  adDataTitle: any;
  imagesCount: any;

  _mySettings: any;

  constructor(public sanitizer: DomSanitizer, private mySettings: SiteConfigurationService) {
    this._mySettings = mySettings.getFullConfig();
   }

  ngOnInit() {

    var imageUrl = "";
    this.imagesCount = 0;

    try {
      imageUrl = JSON.parse(this.adData.Images)[0].url;
      this.imagesCount = JSON.parse(this.adData.Images).length;
      //console.log("Immagini: " + imageUrl);
    } catch (e) {
      imageUrl = "";
      this.imagesCount = 0;
      console.log("Errore ngOnInit 1 try" + e);
    }

    try {
      
      if (imageUrl=="") { 
        imageUrl = this._mySettings.e400.images.noAdsImagePlaceHolder;
      }
      this.imageData = myGlobals.apiBasePath + imageUrl;
      this.imageData = this.sanitizer.bypassSecurityTrustStyle('url(' + this.imageData.replace("(","%28").replace(")","%29") + ')');
    } catch (e) {
      this.imageData = '';
      console.log("Errore ngOnInit 2 try" + e);
    }
    
    if (this.adData.Hierarchy[0].TypeName) { this.adDataTitle = this.adData.Hierarchy[0].TypeName; }
    if (this.adData.GroupAlias) {            this.adDataTitle += ' in ' + this.adData.GroupAlias; }
    if (this.adData.Geo.Aa3) { this.adDataTitle += ' a ' + this.adData.Geo.Aa3; this.adDataTitle += ' (' + this.adData.Geo.Aa2 + ')'; }
    
    var tmpTitle = "";

    try
    {
      tmpTitle = JSON.parse(this.adData.Geo.Extra).label;
    } catch (e) {
      tmpTitle = "";
    }

    if (tmpTitle) { this.adDataTitle += ' in ' + tmpTitle; }

  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnadslist-item/tnadslist-item.component.ts